import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe {
  constructor(private readonly sanitizer: DomSanitizer) { }

  transform(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
